import React, { useState } from "react";
import "./InfluencerWorkSpace.css";
import PromptBar from "./PromptBar";
import ChatHistoryItem from "../modules/Historical List/ChatHistoryItem";

const InfluencerWorkSpace = () => {
  const [post, setPost] = useState("");
  const [scheduledPosts, setScheduledPosts] = useState([]);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [aiResponse, setAiResponse] = useState('');
  const [chatMessages, setChatMessages] = useState([]);

  const handleSchedule = () => {
    if (post.trim() && date && time) {
      const newPost = { text: post, date, time };
      setScheduledPosts([...scheduledPosts, newPost]);
      setPost("");
      setDate("");
      setTime("");
    }
  };

  return (
    <div id='InfluencerWorkSpace'  className="influencer-workspace">
      <h1>✨ Influencer & Coach Workspace</h1>
      <p className="subtitle">
        Create powerful messages, schedule posts, and manage your influence.
      </p>

      {/* Prompt Bar */}
      <div style={{ padding: '16px', background: '#f8f9fa' }}>
        <PromptBar
          onAIResponse={(response) => {
            setAiResponse(response);
            setChatMessages(prev => [...prev, { type: 'ai', content: response, timestamp: new Date() }]);
          }}
          onSearchResults={(results) => {
            setChatMessages(prev => [...prev, { type: 'search', content: results, timestamp: new Date() }]);
          }}
        />
      </div>

      {/* Chat Area */}
      <div className="chat-container">
        {chatMessages.map((message, idx) => (
          <div key={idx} className={`chat-message ${message.type}`}>
            {message.type === 'ai' && (
              <div className="ai-message">
                <div className="ai-avatar">🤖</div>
                <div className="ai-content">
                  <pre>{message.content}</pre>
                </div>
              </div>
            )}
            {message.type === 'search' && (
              <div className="search-message">
                <div className="search-avatar">🔍</div>
                <div className="search-content">
                  <h4>Search Results:</h4>
                  {message.content.map((result, resultIdx) => (
                    <div key={resultIdx} className="search-result-item">
                      <h5>
                        <a href={result.url} target="_blank" rel="noopener noreferrer">
                          {result.title}
                        </a>
                      </h5>
                      <p>{result.description}</p>
                      <small>{result.url}</small>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="editor-section">
        <textarea
          value={post}
          onChange={(e) => setPost(e.target.value)}
          placeholder="Write your impactful message..."
          className="post-editor"
        />
        <div className="schedule-controls">
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
          />
          <button onClick={handleSchedule} className="schedule-btn">
            📅 Schedule Post
          </button>
        </div>
      </div>

      <div className="scheduled-posts">
        <h2>📌 Scheduled Posts</h2>
        {scheduledPosts.length === 0 ? (
          <p>No posts scheduled yet.</p>
        ) : (
          <ul>
            {scheduledPosts.map((p, index) => (
              <li key={index} className="scheduled-item">
                <span>{p.text}</span>
                <span className="datetime">
                  {p.date} at {p.time}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default InfluencerWorkSpace;
